export const theme = {
  yellow: 'hsl(49, 100%, 58%)',
  grey400: 'hsl(0,0%,40%)',
  black: 'hsl(0, 0%, 0%)',
  light: 300,
  bold: 600,
  fontSize: {
    xxs: '1rem',
    xs: '1.2rem',
    s: '1.4rem',
    m: '1.6rem',
    l: '2.4rem',
    xl: '3.5rem',
  },
};
